export class CfTextBlock {
    constructor(entity) {
        const { fields } = entity;
        const { main_title: mainTitle, subtext: subText } = fields;

        Object.assign(this, {
            mainTitle,
            subText,
        });
    }
}
